import { render, staticRenderFns } from "./SolutionDetail.vue?vue&type=template&id=2e356ad6&"
import script from "./SolutionDetail.vue?vue&type=script&lang=js&"
export * from "./SolutionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports